import { ApolloClient, MutationTuple } from '@apollo/client';
import logger from '../common/helpers/logger/logger';
import { useMutationHelper } from '../common/helpers/data/useMutationHelper';
import {
  CommentListQueryResponse,
  CommentMutationResponse,
  CommentMutationVars,
  COMMENT_LIST_QUERY,
  COMMENT_MUTATION,
} from '../queries/contentPage/commentList';

export const useMutationSubmitComment = (): MutationTuple<
  CommentMutationResponse,
  CommentMutationVars
> => {
  try {
    logger.logInfo('commentService.useMutationPostComment', 'Begin');
    return useMutationHelper<CommentMutationResponse, CommentMutationVars>(
      COMMENT_MUTATION,
    );
  } catch (error) {
    logger.logError(
      'commentService.useMutationPostComment',
      'Error creating mutation.',
      error,
    );
    throw error;
  }
};

interface FetchCommentsOptions {
  postId: number;
}

export const fetchComments = async (
  client: ApolloClient<unknown>,
  options: FetchCommentsOptions,
): Promise<CommentListQueryResponse> => {
  try {
    logger.logInfo('commentService.fetchComments', 'Begin', options);

    const variables = { id: options.postId };

    const response = await client.query<CommentListQueryResponse>({
      query: COMMENT_LIST_QUERY,
      variables: variables,
    });

    return response.data;
  } catch (error) {
    logger.logError(
      'commentService.fetchComments',
      'Error retrieving from query.',
      { options, error },
    );
    throw error;
  }
};
